export const DOCUMENTATION_LINK = 'https://upload.qbicsmedia.eu/doc/api.html';
